"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIButtonGroup = _interopRequireDefault(require("UIComponents/button/UIButtonGroup"));

var _UICardGrid = _interopRequireDefault(require("UIComponents/card/UICardGrid"));

var _useResponsiveProps2 = require("ecosystem-marketplace-core/hooks/useResponsiveProps");

var StorefrontCollection = _interopRequireWildcard(require("../../constants/StorefrontCollection"));

var _featuredCollections = require("../../selectors/featuredCollections");

var _env = require("../../utils/env");

var _ResultsSection = _interopRequireDefault(require("../../components/storefront/results/ResultsSection"));

var _ResultsSectionHeader = _interopRequireDefault(require("../../components/storefront/results/ResultsSectionHeader"));

var _AbmCallout = _interopRequireDefault(require("../../components/storefront/callouts/AbmCallout"));

var _StorefrontSectionMarker = _interopRequireDefault(require("../../components/storefront/StorefrontSectionMarker"));

var _constants = require("../../constants");

var _PartnerReliefCallout = _interopRequireDefault(require("../../components/storefront/callouts/PartnerReliefCallout"));

// TEMPORARY - NOT A COLLECTION
var getI18nKey = function getI18nKey(key) {
  return "appMarketplace.storefront.featuredCollections." + key;
};

var getCalloutComponent = function getCalloutComponent(collection) {
  switch (collection) {
    case StorefrontCollection.ABM:
      return _AbmCallout.default;

    case _constants.AMPLIFY_PARTNER_RELIEF:
      return _PartnerReliefCallout.default;

    default:
      return function () {
        return null;
      };
  }
};

var FeaturedCollections = function FeaturedCollections(_ref) {
  var trackSectionInteraction = _ref.trackSectionInteraction;
  var validCallouts = (0, _reactRedux.useSelector)(_featuredCollections.getValidFeaturedCollectionCalloutConfigs);

  var _useState = (0, _react.useState)(validCallouts.size > 1),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      multi = _useState2[0],
      setMulti = _useState2[1];

  var _useResponsiveProps = (0, _useResponsiveProps2.useResponsiveProps)({
    columns: {
      xs: 1,
      lg: multi ? 2 : 1
    }
  }),
      columns = _useResponsiveProps.columns;

  var renderedCallouts = (0, _react.useMemo)(function () {
    return validCallouts.map(function (calloutConfig) {
      var collection = calloutConfig.get('collection');
      var CalloutComponent = getCalloutComponent(collection);
      var sectionName = "amplify-callout::" + collection + "::static";
      return _react.default.createElement(_StorefrontSectionMarker.default, {
        key: collection,
        name: sectionName
      }, _react.default.createElement(CalloutComponent, {
        multi: multi,
        onClick: function onClick() {
          return trackSectionInteraction(sectionName, 'click amplify callout');
        }
      }));
    }).toArray();
  }, [validCallouts, multi, trackSectionInteraction]);
  var renderedDebugControls = (0, _react.useMemo)(function () {
    if (!(0, _env.debug)('featured-collections')) {
      return null;
    }

    return _react.default.createElement(_UIButtonGroup.default, {
      className: "m-bottom-5"
    }, _react.default.createElement(_UIButton.default, {
      active: columns === 1,
      onClick: function onClick() {
        return setMulti(false);
      },
      size: "small",
      use: "tertiary-light"
    }, "1-up"), _react.default.createElement(_UIButton.default, {
      active: columns === 2,
      onClick: function onClick() {
        return setMulti(true);
      },
      size: "small",
      use: "tertiary-light"
    }, "2-up"));
  }, [columns]);

  if (!validCallouts.size) {
    return null;
  }

  return _react.default.createElement(_ResultsSection.default, null, _react.default.createElement(_ResultsSectionHeader.default, {
    className: "p-bottom-0",
    details: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('subheadingText')
    }),
    headingLevel: "h4",
    title: _react.default.createElement(_FormattedMessage.default, {
      message: getI18nKey('titleText')
    })
  }), renderedDebugControls, _react.default.createElement(_UICardGrid.default, {
    columns: columns
  }, renderedCallouts));
};

FeaturedCollections.propTypes = {
  trackSectionInteraction: _propTypes.default.func.isRequired
};
var _default = FeaturedCollections;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/containers/storefront/FeaturedCollections.js
// module id = 891
// module chunks = 209 210 211 212